module.exports = __webpack_public_path__ + "img/time_boundary_event_noselect.3c743a0c.svg";